export default [
  {
    path: '/halal-operation-engineers',
    name: 'halal-operation-engineers',
    component: () => import('@/views/halal/operation-engineers/OperationEngineers.vue'),
    meta: {
      title: 'halal CE',
      requiresAuth: true,
      action: 'browes',
      resource: 'halal CE',
      pageTitle: 'Halal',
      breadcrumb: [
        {
          text: 'halal CE',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
]
